import { useContext } from '@max/max';
const isWeb = true;
const isMRN = false;
import { getSystemInfoSync } from '@max/meituan-uni-system';
// eslint-disable-next-line import/no-cycle
import { getUTM } from './getUTM';
import { getPlatformType, PlatformType } from '@nibfe/mkt-env-api';
import { PlatformEnum } from '../constants';
export const { statusBarHeight, screenHeight, screenWidth, appId = '', platform } = getSystemInfoSync() || {};
const platformType = getPlatformType();
const isDp = [PlatformType.dpApp, PlatformType.dpAppWebView, PlatformType.dpMinaWebview].includes(platformType);
const DEFAULT_CITY_ID = 1;
export const IS_DP = String(appId) === '1';
export const IS_MT = String(appId) === '10';
export const isAndroid = platform === 'android' || platform === 'Android';
export function reverseRem(size, factor = 375, foldAdapter = false, screenWidthBelow360NeedScale = false) {
    if (screenWidth > 0 && screenHeight / screenWidth <= 1.33 && !foldAdapter) {
        return size;
    }
    if (!screenWidthBelow360NeedScale && screenWidth < 360) {
        return size;
    }
    return size / screenWidth * factor;
}
export function getImage(uri) {
    return {
        uri
    };
}
export function handleUrl(url) {
    var _a;
    return `${(_a = url === null || url === void 0 ? void 0 : url.replace('/w.h/', '/')) === null || _a === void 0 ? void 0 : _a.replace('http://', 'https://')}@240w_286h_1e_1c`;
}
export const isInWX = () => {
    if (true) {
        return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
    }
    return false;
};
export const getQuery = () => {
    const url = window.location.href.split('?');
    const rl = url.length;
    let a;
    let h;
    let l;
    let e;
    const r = {};
    if (rl > 1) {
        for (let m = 1; m < rl; m++) {
            h = url[m].split('#');
            a = h[0].split('&');
            l = a.length;
            for (let i = 0; i < l; i++) {
                e = a[i].split('=');
                if (e.length > 1)
                    r[e[0]] = e[1];
            }
        }
    }
    return r;
};
/**
 * 登录相关的方法封装
 */
export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
};
export function rpxToVW(pos) {
    return `${pos * 100 / 750}vw`;
}
// 是否是生产环境
export function isProductionEnv() {
    var _a, _b;
    if (isWeb) {
        const env = (_b = (_a = window === null || window === void 0 ? void 0 : window.process) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b.NODE_ENV;
        if (env === 'production') {
            return true;
        }
        if (true) {
            return window.location.href.indexOf('meituan.com') > 0;
        }
        return false;
    }
}
// 从url获取参数
export function getParamsFromUrl() {
    const decode = (name) => {
        // const res = '';
        const param = undefined;
        return param;
    };
    const id = decode('cityId');
    let cityId = -1;
    try {
        cityId = id ? parseInt(id) : -1;
    }
    catch (e) {
        console.log('cityId err', e);
    }
    const utm_medium = getUTM();
    return {
        utm_medium,
        version_name: decode('version_name') || '999.9',
        // >12.3.204
        cityItem: {
            label: decode('cityName') || '',
            // 取不到 由业务自己写
            value: cityId // 取不到 默认-1;
        }
    };
}
export function getParamsFromProp(props) {
    const { attr_28, inputFilter, limitNum, hourRoom } = props;
    const res = {
        attr_28: attr_28 || 129,
        limit: limitNum || 20,
        filterids: hourRoom
    };
    if (inputFilter === null || inputFilter === void 0 ? void 0 : inputFilter.length) {
        inputFilter.forEach((filter) => {
            const { itemName, selectKey, selectValue } = filter;
            if (itemName && selectKey && selectValue) {
                res[selectKey] = selectValue;
            }
        });
    }
    return res;
}
export function useEngineContext() {
    // @ts-expect-error no global
    const ctx = useContext(global._EngineGlobalContext);
    return ctx;
}
const getCityNameByCityId = (cityId, cityInfos) => {
    if (Array.isArray(cityInfos) && cityInfos.length > 0) {
        const cityInfo = cityInfos.find(item => String(item.id) === String(cityId));
        return (cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.name) || '';
    }
    return '';
};
export function getActualCityId(props) {
    var _a, _b;
    const { ctx } = props;
    const runtimeInfo = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo;
    const queryParams = runtimeInfo === null || runtimeInfo === void 0 ? void 0 : runtimeInfo.queryParams;
    const commonParams = runtimeInfo === null || runtimeInfo === void 0 ? void 0 : runtimeInfo.commonParams;
    // 优先从查询参数获取城市id
    if (queryParams === null || queryParams === void 0 ? void 0 : queryParams.cityId) {
        let cityName = queryParams.cityName;
        if (!cityName) {
            cityName = getCityNameByCityId(queryParams.cityId, props.cityInfos);
        }
        if (cityName) {
            console.log('get cityid from jumpUrl', queryParams.cityId);
            return {
                cityId: Number(queryParams.cityId),
                cityName,
                type: 'queryParams'
            };
        }
    }
    // 获取小环境城市
    if ((_a = commonParams === null || commonParams === void 0 ? void 0 : commonParams.cityInfo) === null || _a === void 0 ? void 0 : _a.cityId) {
        let cityName = commonParams.cityInfo.cityName;
        if (!cityName) {
            cityName = getCityNameByCityId(commonParams.cityInfo.cityId, props.cityInfos);
        }
        if (cityName) {
            console.log('get cityid from commonParams', commonParams.cityInfo.cityId);
            return {
                cityId: Number(commonParams.cityInfo.cityId),
                cityName,
                type: 'homePage'
            };
        }
    }
    if ((_b = commonParams === null || commonParams === void 0 ? void 0 : commonParams.cityInfo) === null || _b === void 0 ? void 0 : _b.locCityId) {
        let cityName = commonParams.cityInfo.cityName;
        if (!cityName) {
            cityName = getCityNameByCityId(commonParams.cityInfo.locCityId, props.cityInfos);
        }
        if (cityName) {
            console.log('get loc cityId from commonParams', commonParams.cityInfo.locCityId);
            return {
                cityId: Number(commonParams.cityInfo.locCityId),
                cityName,
                type: 'locCityId'
            };
        }
    }
    return {
        cityId: isDp ? 2 : 1,
        cityName: '北京',
        type: 'default'
    };
}
export const getRequestPlatform = () => {
    try {
        let result = PlatformEnum.mtApp;
        let platform = 'mtApp';
        platform = getPlatformType();
        if (Object.keys(PlatformEnum).indexOf(platform) > -1 && PlatformEnum[platform]) {
            result = PlatformEnum[platform];
        }
        return result;
    }
    catch (e) {
        return PlatformEnum.mtApp;
    }
};
